export default "__VITE_ASSET__Cf91ytRp__"